type Curry<T extends (...args: any[]) => any, P extends any[]> = (
  ...args: DropParameters<Parameters<T>, P>
) => ReturnType<T>

type DropParameters<T extends any[], U extends any[]> = T extends [...U, ...infer R] ? R : never

export function curry<T extends (...args: any[]) => any, P extends any[]>(fn: T, ...args: P): Curry<T, P> {
  return ((...rest: any[]) => fn(...args, ...rest)) as Curry<T, P>
}

// 示例函数
// function fun1(a: string, b: number, c: string): number {
//   // 示例逻辑
//   console.log(a, b, c);
//   return b;
// }

// // 测试
// const fun2 = curry(fun1, "A");
// fun2(1, "B"); // 相当于调用 fun1("A", 1, "B")

// const fun3 = curry(fun1, "AA", 2);
// fun3("S"); // 相当于调用 fun1("AA", 2, "S")
